import { mobileItemDetailActions } from '../../services';


export const mobileItemDetailDispatcher = dispatch => ({
    addComponentToMobileItem : (data) => dispatch({type:mobileItemDetailActions.ADD, data:data}),
});